import { SEND_MESSAGE_TYPES, SEND_MESSAGE_TYPES_ARRAY } from 'utils/config'
import { CustomYup } from 'validations/CustomYup'

export const sendMessageToProjectUsersSchema = CustomYup.object().shape({
  message: CustomYup.string().required(),
  group: CustomYup.string().required(),
  type: CustomYup.string().oneOf(SEND_MESSAGE_TYPES_ARRAY.map((type) => type.value)),
  subject: CustomYup.mixed().when('type', {
    is: (type) => type == SEND_MESSAGE_TYPES.email.value,
    then: () => CustomYup.string().required(),
    otherwise: () => CustomYup.string().nullable(),
  }),
})

export default sendMessageToProjectUsersSchema
